import { GQLContentPagePageComponentType } from '@theprintbar/graphql';
import {
	CalloutCTA,
	CalloutCTA2,
	FullCTA,
	ImageSplitCTA,
	ImageSplitCTA2,
	RoundedCTA,
	SimpleCTA,
	SimpleCTA2,
	SmallArrowIcon,
	SplitCTA,
	SplitCTA2,
} from '@theprintbar/ui';
import { GetComponentProps } from '~/routes/_layout/$/utils/getComponent';
import { TitleSectionContent, TitleSectionProps } from '../../../../packages/ui/src/components/TitleSection';

export function getCTA({ contentPage, index, type, nextType }: GetComponentProps) {
	let titleContainer: TitleSectionContent | null = null;
	let titleSectionProps: Partial<TitleSectionProps> = {};
	let component: JSX.Element | null;
	const isHero = !index;
	// might update later
	const setFullHeroSectionProps = isHero
		? { className: 'py-0 lg:py-0 my-0 lg:my-0', containerClass: 'px-0 lg:px-0' }
		: { className: 'py-0 lg:py-0 my-0 lg:my-0', containerClass: 'px-0 lg:px-0' };

	switch (type) {
		case GQLContentPagePageComponentType.CalloutCta:
			titleContainer = contentPage.calloutCTAContainer;
			titleSectionProps = { className: 'my-0 lg:my-0' };
			component = <CalloutCTA content={contentPage} />;
			break;
		case GQLContentPagePageComponentType.CalloutCta2:
			titleContainer = contentPage.calloutCTAContainer2;
			titleSectionProps = { className: 'my-0 lg:my-0' };
			component = <CalloutCTA2 content={contentPage} />;
			break;
		case GQLContentPagePageComponentType.FullCta:
			titleSectionProps = setFullHeroSectionProps;
			titleContainer = contentPage.fullCTAContainer;
			component = <FullCTA cta={contentPage.fullCTA} hero={!index} />;
			break;
		case GQLContentPagePageComponentType.FullCta2:
			titleSectionProps = setFullHeroSectionProps;
			titleContainer = contentPage.fullCTAContainer2;
			component = <FullCTA cta={contentPage.fullCTA2} hero={!index} />;
			break;
		case GQLContentPagePageComponentType.FullCtaReversed:
			titleSectionProps = setFullHeroSectionProps;
			titleContainer = contentPage.fullCTAContainer;
			component = <FullCTA cta={contentPage.fullCTAReversed} reversed hero={!index} />;
			break;
		case GQLContentPagePageComponentType.FullCtaReversed2:
			titleSectionProps = setFullHeroSectionProps;
			titleContainer = contentPage.fullCTAContainer2;
			component = <FullCTA cta={contentPage.fullCTAReversed2} reversed hero={!index} />;
			break;
		case GQLContentPagePageComponentType.FullRoundedCta:
			titleSectionProps = setFullHeroSectionProps;
			titleContainer = contentPage.fullRoundedCTAContainer;
			component = <FullCTA cta={contentPage.fullRoundedCTA} rounded hero={!index} />;
			break;
		case GQLContentPagePageComponentType.FullRoundedCta2:
			titleSectionProps = setFullHeroSectionProps;
			titleContainer = contentPage.fullRoundedCTAContainer2;
			component = <FullCTA cta={contentPage.fullRoundedCTA2} rounded hero={!index} />;
			break;
		case GQLContentPagePageComponentType.FullRoundedCtaReversed:
			titleSectionProps = setFullHeroSectionProps;
			titleContainer = contentPage.fullRoundedCTAReversedContainer;
			component = <FullCTA cta={contentPage.fullRoundedCTAReversed} hero={!index} rounded reversed />;
			break;
		case GQLContentPagePageComponentType.FullRoundedCtaReversed2:
			titleSectionProps = setFullHeroSectionProps;
			titleContainer = contentPage.fullRoundedCTAReversedContainer2;
			component = <FullCTA cta={contentPage.fullRoundedCTAReversed2} hero={!index} rounded reversed />;
			break;
		case GQLContentPagePageComponentType.ImageSplitCta:
			component = <ImageSplitCTA content={contentPage} />;
			titleContainer = contentPage.imageSplitCTAContainer;
			titleSectionProps.buttonIcon = SmallArrowIcon;
			if (nextType === GQLContentPagePageComponentType.LinkTiles) {
				titleSectionProps.className = 'mb-0 lg:mb-0';
			}
			break;
		case GQLContentPagePageComponentType.ImageSplitCta2:
			component = <ImageSplitCTA2 content={contentPage} />;
			titleContainer = contentPage.imageSplitCTAContainer2;
			titleSectionProps.buttonIcon = SmallArrowIcon;
			if (nextType === GQLContentPagePageComponentType.LinkTiles) {
				titleSectionProps.className = 'mb-0 lg:mb-0';
			}
			break;
		case GQLContentPagePageComponentType.RoundedCta:
			titleContainer = contentPage.roundedCTAContainer;
			component = <RoundedCTA cta={contentPage.roundedCTA} />;
			break;
		case GQLContentPagePageComponentType.RoundedCta2:
			titleContainer = contentPage.roundedCTAContainer2;
			component = <RoundedCTA cta={contentPage.roundedCTA2} />;
			break;
		case GQLContentPagePageComponentType.RoundedCtaReversed:
			titleContainer = contentPage.roundedCTAReversedContainer;
			component = <RoundedCTA cta={contentPage.roundedCTAReversed} reversed />;
			break;
		case GQLContentPagePageComponentType.RoundedCtaReversed2:
			titleContainer = contentPage.roundedCTAReversedContainer2;
			component = <RoundedCTA cta={contentPage.roundedCTAReversed2} reversed />;
			break;
		case GQLContentPagePageComponentType.RoundedSplitCta:
			component = <RoundedCTA cta={contentPage.roundedSplitCTA} split />;
			titleContainer = contentPage.roundedSplitCTAContainer;
			break;
		case GQLContentPagePageComponentType.RoundedSplitCta2:
			component = <RoundedCTA cta={contentPage.roundedSplitCTA2} split />;
			titleContainer = contentPage.roundedSplitCTAContainer2;
			break;
		case GQLContentPagePageComponentType.RoundedSplitCtaReversed:
			titleContainer = contentPage.roundedSplitCTAReversedContainer;
			component = <RoundedCTA cta={contentPage.roundedSplitCTAReversed} split reversed />;
			break;
		case GQLContentPagePageComponentType.RoundedSplitCtaReversed2:
			titleContainer = contentPage.roundedSplitCTAReversedContainer2;
			component = <RoundedCTA cta={contentPage.roundedSplitCTAReversed2} split reversed />;
			break;
		case GQLContentPagePageComponentType.SimpleCta:
			component = <SimpleCTA content={contentPage} />;
			break;
		case GQLContentPagePageComponentType.SimpleCta2:
			component = <SimpleCTA2 content={contentPage} />;
			break;
		case GQLContentPagePageComponentType.SplitCta:
			titleContainer = contentPage.splitCTAContainer;
			component = <SplitCTA content={contentPage} />;
			break;
		case GQLContentPagePageComponentType.SplitCta2:
			titleContainer = contentPage.splitCTAContainer2;
			component = <SplitCTA2 content={contentPage} />;
			break;
		default:
			component = null;
			break;
	}

	return {
		component,
		ctaTitleSectionProps: titleSectionProps,
		titleContainer,
	};
}
